// Image to Video
export const MAX_IMAGES = 12;
export const MAX_TOTAL_DURATION = 60; // Max total duration for final video
export const MAX_DURATION_PER_IMAGE = 60; // Can use full duration on a single slide if desired

// common view
export const PORTRAIT_WIDTH = 720;
export const PORTRAIT_HEIGHT = 1280;

export const PORTRAIT_HD_WIDTH = 1080;
export const PORTRAIT_HD_HEIGHT = 1920;

export const LANDSCAPE_WIDTH = 1280;
export const LANDSCAPE_HEIGHT = 720;

export const SQUARE_WIDTH = 720;
export const SQUARE_HEIGHT = SQUARE_WIDTH;

export const THREE_BY_FOUR_WIDTH = 960;
export const THREE_BY_FOUR_HEIGHT = 720;

export const FOUR_BY_THREE_WIDTH = 720;
export const FOUR_BY_THREE_HEIGHT = 960;

export const BANNER_WIDTH = 2048;
export const BANNER_HEIGHT = 1152;

// common text editor
export const FONT_OPTIONS = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Courier New', label: 'Courier New' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Impact', label: 'Impact' },
  { value: 'Comic Sans MS', label: 'Comic Sans' },
  { value: 'Trebuchet MS', label: 'Trebuchet' },
  { value: 'Arial Black', label: 'Arial Black' },
  { value: 'Poppins', label: 'Poppins' },
  { value: 'Montserrat', label: 'Montserrat' },
  { value: 'Oswald', label: 'Oswald' },
  { value: 'Roboto', label: 'Roboto' },
  { value: 'Lato', label: 'Lato' },
];

const LEGACY_FONT_ALIASES: Record<string, string> = {
  'Arial, sans-serif': 'Arial',
  'Helvetica, sans-serif': 'Helvetica',
  '"Times New Roman", serif': 'Times New Roman',
  '"Courier New", monospace': 'Courier New',
  'Georgia, serif': 'Georgia',
  'Verdana, sans-serif': 'Verdana',
  'Impact, fantasy': 'Impact',
  '"Comic Sans MS", cursive': 'Comic Sans MS',
  '"Trebuchet MS", sans-serif': 'Trebuchet MS',
};

export function normalizeFontFamily(fontFamily?: string): string {
  if (!fontFamily) {
    return FONT_OPTIONS[0].value;
  }
  return LEGACY_FONT_ALIASES[fontFamily] || fontFamily;
}


// Video Editor
export const MAX_DURATION_VIDEO_EDITOR = 600; // seconds


// Composer Common
export const FPS = 30;

//blog constants
export const POSTS_PER_PAGE = 8;
export const SEARCH_DEBOUNCE_MS = 300;

